import { render, staticRenderFns } from "./SelectedUsers.vue?vue&type=template&id=e7e46ff6&"
import script from "./SelectedUsers.vue?vue&type=script&lang=ts&"
export * from "./SelectedUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports